import { createTechnicalBase } from '../../shared/technicalBase'

const base = createTechnicalBase()

export default {
    namespaced: true,
    state() {
        return {
            ...base.state(),
            currentTech: -1,
        }
    },
    getters: {
        ...base.getters,
        getCurrentTech(state) {
            return state.currentTech
        }
    },
    mutations: {
        ...base.mutations,
        SET_CURRENT(state, val) {
            state.currentTech = val;
        }
    },
    actions: {
        ...base.actions,
        setCurrentTech({ commit }, value) {
            commit('SET_CURRENT', value);
        }
    }
}
